module.exports = __webpack_public_path__ + "static/media/Formular-MediumItalic.c3f698dd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Formular-MediumItalic.woff
// module id = 276
// module chunks = 0